import React from "react";
import { BoardProps } from "./types/types";
import BoardType1 from "./hooks/type1/BoardType1";
import BoardType2 from "./hooks/type2/BoardType2";
import BoardType3 from "./hooks/type3/BoardType3";

import "../styles/TablesSBoard.css"

const Board: React.FC<BoardProps> = (props) => {
  if (props.type === 1) {
    return <BoardType1 {...props} />;
  }
    if (props.type === 2) {
    return <BoardType2 {...props} />;
  }
  if (props.type ===3) {
    return <BoardType3 {...props} />;
  }

  return null;
};

export default Board;